import { Paragraph } from '@zillow/constellation-10';

const PetPolicyWizardTipContent = () => {
  return (
    <div data-testid="WizardTipContent">
      <Paragraph css={{ marginBottom: '400' }}>
        You may be able to attract more applicants by allowing pets — 65% of renters say allowing pets is essential when
        deciding whether to rent a property.
      </Paragraph>
      <Paragraph textStyle="body-xs" color="text.subtle">
        Source: Zillow Consumer Housing Trends Report 2025
      </Paragraph>
    </div>
  );
};

export default PetPolicyWizardTipContent;
